import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=f2348e4a&scoped=true"
import script from "./MegaMenu.vue?vue&type=script&lang=js"
export * from "./MegaMenu.vue?vue&type=script&lang=js"
import style0 from "./MegaMenu.vue?vue&type=style&index=0&id=f2348e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2348e4a",
  null
  
)

export default component.exports